import React from "react";

import { isAuctionItem } from "utils/auctionFlags";

export default function AuctionIndicator({ item, className = "", style = {} }) {
  if (!isAuctionItem(item)) return null;

  return (
    <span
      aria-label="מכרז"
      title="מכרז"
      className={`absolute ${className}`}
      style={{
        zIndex: 999,
        backgroundColor: "white",
        width: 44,
        height: 44,
        padding: 8,
        top: 12,
        right: 12,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...style,
      }}
    >
      <img src="/icons/tender.svg" alt="מכרז" style={{ width: 20, height: 20 }} />
    </span>
  );
}
